export const iconFontAwesomeLogisticsPlaneCircleExclamation = (
	<i className="fa-solid fa-plane-circle-exclamation"></i>
);
